import React from 'react';
import {Button, Snackbar} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface LayerUndoSnackbarProps {
    open: boolean;
    onUndo: () => void;
    onClose: () => void;
}

/** Deleting a user layer drops three pieces of state at once (the record, its
 *  value, its geometry) and the end-user editor has no undo stack of any kind —
 *  so the delete has to carry its own way back. Auto-hides; the timeout is the
 *  commit. */
const LayerUndoSnackbar: React.FC<LayerUndoSnackbarProps> = ({open, onUndo, onClose}) => {
    const {t} = useTranslation();
    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={onClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            message={t('editor.layers.deleted')}
            data-testid="layer-undo-snackbar"
            action={
                <Button
                    size="small"
                    onClick={onUndo}
                    data-testid="layer-undo-button"
                    sx={{color: '#00E162', fontWeight: 700}}
                >
                    {t('editor.layers.undo')}
                </Button>
            }
            // Above the Fill Mode sticky bar, below the bottom sheets.
            sx={{'& .MuiSnackbarContent-root': {backgroundColor: '#0a1f33', color: 'white'}, zIndex: 1250}}
        />
    );
};

export default LayerUndoSnackbar;
